export default "__VITE_ASSET__BrJLhr$L__"